<template>
  <div class="apps">
    <div class="toast" v-if="!is">
      暂无内容
    </div>

    <div v-else style="position: relative;">
      <!-- <div class="shang">
        <div class="logo">
          <img :src="pageData.show_img" alt="">
        </div>
        <div class="text" style="text-align: center;width: 200px;height: 18px;line-height: 18px;">{{ name }}</div>
      </div> -->
      <!-- <div class="text_box" v-html="pageData.content"></div> -->
      <div class="" v-html="pageData.content"></div>
      <div class="imgs_box"></div>
    </div>

    <div class="back" @click="$router.back()">返回</div>

  </div>
</template>
  
<script>
import axios from "axios";
export default {
  data() {
    return {
      pageData: [],
      name: '',
      is: true,
      imgList: []
    }
  },
  methods: {
    getName() {
      axios({
        url: this.base_url.base_url + '/index.php/index/index/navigation_list',
        method: 'get',
      }).then((res) => {
        res.data.data.bottom_list[2].child.forEach(v => {
          if (v.id == this.$route.query.cid) {
            this.name = v.t_name_deputy
          }
        })
      }).catch((err) => {
        console.log(err);
      })
    },
    getData() {
      axios({
        url: this.base_url.base_url + '/index.php/index/index/news_list?nid=11&cid=' + this.$route.query.cid,
        method: 'get',
      }).then((res) => {
        if (!res.data.data.news_data[0]) {
          this.is = false
        } else {
          this.is = true
          this.pageData = res.data.data.news_data[0]
        }
      }).catch((err) => {
        console.log(err);
      })
    },
  },
  created() {
    this.getData()
    this.getName()

  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1920px) {
  .text_box {
    width: 1737px !important;

    :deep(p) {
      width: 1737px;

      img {
        width: 1737px !important;
      }
    }
  }
}

.apps {
  padding-top: 63px;
  display: flex;
  flex-direction: column;

  .toast {
    text-align: center;
  }

  // overflow:hidden

  .shang {
    width: 200px;
    height: 300px;
    margin: 0 auto;

    .logo {
      width: 200px;
      height: 89px;
      margin-bottom: 19px;

      :deep(img) {
        width: 319px;
        height: 205px;
      }
    }


    .text {
      width: 166px;
      height: 12px;
      font-size: 16px;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      color: #949594;
      line-height: 30px;
    }
  }

  .text_box {
    width: 1920px;
    margin: 0 auto;
    overflow: auto;

    :deep(p) {
      img {
        float: none !important;
      }
    }
  }

  .back {
    // position: absolute;
    margin-top: 30px;
    width: 1306px;
    height: 60px;
    margin: 30px auto 40px;
    background-color: #f4f8fb;
    text-align: center;
    line-height: 60px;
    cursor: pointer;
  }
}</style>